/** JSON.stringify replacer that keeps tokens in a response body, such as the MQTT broker check's, out of the log. */
export function redactTokens(key: string, value: unknown): unknown {
    return key === 'token' ? '[redacted]' : value;
}
